// The kinds of play a season or a competition falls in (notes 10/21 D6,
// users/profile_seasons.play_group: GROUP_LABELS there) and the words every
// profile surface prints for them: the box score's School | Grassroots
// switch and the competition lines' tags (PlayerProfile/profileModel), Game
// by Game's grouped season list and its lede badge
// (v2/performance/athletePerformanceModel). One place, so the two never
// read differently.
export const PLAY_GROUP_LABELS = Object.freeze({
  school: "School",
  grassroots: "Grassroots",
  college: "College",
  pro: "Pro",
  camp: "Camp",
  other: "Other events",
});

// Their one order: the box score switch's (School | Grassroots, then
// College and Pro when the athlete played there), then the kinds no peer
// group ranks.
export const PLAY_GROUP_ORDER = Object.freeze(["school", "grassroots", "college", "pro", "camp", "other"]);
